function isAllZeros(str: any) {
    return /^0+$/.test(str);
}
//--------------------------------

export const DashboardIcon = () => (
    <svg className="icon" fill="none" strokeWidth="2" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h7.5"></path></svg>
);
export const UsersIcon = () => (
    <svg className="icon" fill="none" strokeWidth="2" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A1.75 1.75 0 0 1 18 21H6a1.75 1.75 0 0 1-1.499-.882Z"></path></svg>
);
export const TransactionsIcon = () => (
    <svg className="icon" fill="none" strokeWidth="2" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 4.5v15a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25Zm13.5 0-4.5 4.5-4.5-4.5m4.5 15v-12"></path></svg>
);
export const ReconciliationIcon = () => (
    <svg className="icon" fill="none" strokeWidth="2" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.5h3.832a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25h3.832M12 6.75h.008v.008H12V6.75Z"></path></svg>
);
export const MenuIcon = () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
);
export const ChevronDoubleLeftIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
    </svg>
);
export const formatNumber = (number: any, max: any) => {
    if (Number(number) >= 1) {
        let [integerPart, decimalPart] = number.toString().split('.');
        if (integerPart !== '0') {
            integerPart = parseInt(integerPart).toLocaleString('en-US');
        }
        decimalPart = decimalPart ? decimalPart.substring(0, max) : '';
        if (isAllZeros(decimalPart)) {
            decimalPart = ''
        }
        return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    } else if (Number(number) < 1) {
        const factor = Math.pow(10, max);
        return Math.floor(number * factor) / factor;
        //      let bigNum = new BigNumber(number);
        // return bigNum.toFixed(max, BigNumber.ROUND_DOWN);
    } else {
        return 0
    }
}

export const formatTimestamp = (isoString: string) => {
    if (!isoString) return 'N/A';
    try {
        const date = new Date(isoString);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
        return 'N/A';
    }
};

export const truncateText = (text: string, maxLength: number = 20) => {
    if (!text || text.length <= maxLength) {
        return text;
    }
    const startLength = Math.floor((maxLength - 3) / 2);
    const endLength = Math.ceil((maxLength - 3) / 2);
    return `${text.substring(0, startLength)}...${text.substring(text.length - endLength)}`;
};